const DeviceView = () =>
  import(/* webpackChunkName: "devices-view" */ '@/components/device/device-view');
const SubstationDevices = () =>
  import(/* webpackChunkName: "devices-view" */ '@/components/substations/devices');

const DEVICES_ROUTES = [
  {
    path: '/project/:projectCode/substation/:substationCode',
    name: 'substationDevices',
    component: SubstationDevices,
    meta: { showWide: true },
    props: true
  },
  {
    path:
      '/project/:projectCode/substation/:substationCode/agent/:agentCode/:deviceType/modbus-:modbusAddress?',
    component: DeviceView,
    name: 'device',
    props: true,
    meta: { showWide: true }
  }
];

export default DEVICES_ROUTES;
